export const SUPPORTED_LANGUAGES = {
  EN: 'en',
  ES: 'es',
} as const

export const DATE_FORMAT_LOCALES = {
  EN: 'en-US',
  ES: 'es-ES',
} as const
